export const HOST: string = process?.env?.NEXT_PUBLIC_HOST
  ? process?.env?.NEXT_PUBLIC_HOST.toString().trim()
  : ''
export const S_DEBUG_MODE: boolean = process?.env?.SECURE_DEBUG_MODE
  ? process?.env?.SECURE_DEBUG_MODE?.toString().trim() == 'true'
    ? true
    : false
  : false
export const S_ENVIRONMENT: string = process?.env?.SECURE_ENVIRONMENT
  ? process?.env?.SECURE_ENVIRONMENT?.toString().trim()
  : 'dev'
export const IS_PRODUCTION: boolean = S_ENVIRONMENT == 'prod' ? true : false
export const IS_QA: boolean = S_ENVIRONMENT == 'dev' ? true : false
export const IS_LOCAL: boolean = S_ENVIRONMENT == 'local' ? true : false
export const S_HOST: string = process?.env?.SECURE_HOST
  ? process?.env?.SECURE_HOST.toString().trim()
  : ''
export const DO_RATE_LIMITING: boolean = false
export const UPSTASH_API_KEY: string = process?.env?.SECURE_UPSTASH_API_KEY
  ? process?.env?.SECURE_UPSTASH_API_KEY
  : ''
export const UPSTASH_ENDPOINT: string = process?.env?.SECURE_UPSTASH_ENDPOINT
  ? process?.env?.SECURE_UPSTASH_ENDPOINT
  : ''
export const FIRECRAWL_API_KEY: string = process?.env?.SECURE_FIRECRAWL_API_KEY
  ? process?.env?.SECURE_FIRECRAWL_API_KEY?.toString().trim()
  : ''
export const P3_API_DOMAIN: string = process?.env?.SECURE_P3_API_DOMAIN
  ? process?.env?.SECURE_P3_API_DOMAIN?.toString().trim()
  : ''
export const P3_API_ACTION_SECRET: string = process?.env
  ?.SECURE_P3_API_ACTION_SECRET
  ? process?.env?.SECURE_P3_API_ACTION_SECRET?.toString().trim()
  : ''
export const ENV_PASSCODE: string = process?.env?.SECURE_ENV_PASSCODE
  ? process?.env?.SECURE_ENV_PASSCODE?.toString().trim()
  : ''

export const REDIS_HOST: string = process?.env?.SECURE_REDIS_HOST
  ? process?.env?.SECURE_REDIS_HOST?.toString().trim()
  : ''
export const REDIS_PASSWORD: string = process?.env?.SECURE_REDIS_PASSWORD
  ? process?.env?.SECURE_REDIS_PASSWORD?.toString().trim()
  : ''
export const REDIS_USERNAME: string = process?.env?.SECURE_REDIS_USERNAME
  ? process?.env?.SECURE_REDIS_USERNAME?.toString().trim()
  : ''
export const REDIS_PORT: number = process?.env?.SECURE_REDIS_PORT
  ? parseInt(process?.env?.SECURE_REDIS_PORT?.toString().trim())
  : 11433
export const REDIS_REFRESH_TOKEN_INTERNAL_SECRET: string = process?.env
  ?.SECURE_REDIS_REFRESH_TOKEN_INTERNAL_SECRET
  ? process?.env?.SECURE_REDIS_REFRESH_TOKEN_INTERNAL_SECRET?.toString().trim()
  : ''
export const LLMS_FULL_REDIS_LAST_CACHED: string = process?.env
  ?.SECURE_LLMS_FULL_REDIS_LAST_CACHED
  ? process?.env?.SECURE_LLMS_FULL_REDIS_LAST_CACHED?.toString().trim()
  : ''
export const LLMS_FULL_REDIS_CACHE_NAME: string = process?.env
  ?.SECURE_LLMS_FULL_REDIS_CACHE_NAME
  ? process?.env?.SECURE_LLMS_FULL_REDIS_CACHE_NAME.toString().trim()
  : ''
export const LLMS_REDIS_LAST_CACHED: string = process?.env
  ?.SECURE_LLMS_REDIS_LAST_CACHED
  ? process?.env?.SECURE_LLMS_REDIS_LAST_CACHED?.toString().trim()
  : ''
export const LLMS_REDIS_CACHE_NAME: string = process?.env
  ?.SECURE_LLMS_REDIS_CACHE_NAME
  ? process?.env?.SECURE_LLMS_REDIS_CACHE_NAME?.toString().trim()
  : ''
export const LLMS_RESPONSE_CACHE_REVALIDATE_MINUTES: number = 20160
export const LLMS_FULL_RESPONSE_CACHE_REVALIDATE_MINUTES: number = 20160
